import { useDispatch, useSelector } from 'react-redux';
import { Spacer, Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { REGISTER_URL } from 'constants/routes';
import { onA11yKeyDown } from 'data/utils/a11y';
import { getOldHostRedirectUrl } from 'libs/utils/url';
import { navigateToPage } from 'libs/utils/window';
import { AuthView } from 'state/auth/constants';
import { getIsSelectTypeLogin } from 'state/auth/selectors';
import { actions } from 'state/auth/slice';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const SelectTypeFooter = () => {
  const isLoginView = useSelector(getIsSelectTypeLogin);
  const dispatch = useDispatch();
  const selectType = isLoginView ? 'login' : 'register';
  const translate = useTranslate("auth.select_type.".concat(selectType));

  function handleSwitchContext() {
    dispatch(actions.setAuthView({
      authView: isLoginView ? AuthView.SelectTypeRegister : AuthView.SelectTypeLogin
    }));
  }

  function proceedToEmailLogin() {
    dispatch(actions.setAuthView({
      authView: AuthView.EmailLogin
    }));
  }

  function proceedToEmailRegister() {
    const hostRedirectUrl = getOldHostRedirectUrl();

    if (hostRedirectUrl) {
      navigateToPage("".concat(hostRedirectUrl).concat(REGISTER_URL));
      return;
    }

    dispatch(actions.setAuthView({
      authView: AuthView.EmailRegister
    }));
  }

  function handleProceedLinkClick() {
    if (isLoginView) {
      proceedToEmailLogin();
    } else {
      proceedToEmailRegister();
    }
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Text, {
      width: Text.Width.Parent,
      alignment: Text.Alignment.Center,
      children: [translate('actions.proceed.title'), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Small
      }), /*#__PURE__*/_jsx("span", {
        role: "button",
        onKeyDown: onA11yKeyDown,
        className: "u-cursor-pointer",
        tabIndex: 0,
        onClick: handleProceedLinkClick,
        "data-testid": "auth-select-type--".concat(selectType, "-email"),
        children: /*#__PURE__*/_jsx(Text, {
          text: translate('actions.proceed.link'),
          theme: "primary"
        })
      })]
    }), /*#__PURE__*/_jsx(Spacer, {}), /*#__PURE__*/_jsxs(Text, {
      width: Text.Width.Parent,
      alignment: Text.Alignment.Center,
      children: [translate('actions.switch.title'), /*#__PURE__*/_jsx(Spacer, {
        orientation: Spacer.Orientation.Vertical,
        size: Spacer.Size.Small
      }), /*#__PURE__*/_jsx("span", {
        role: "button",
        onClick: handleSwitchContext,
        onKeyDown: onA11yKeyDown,
        className: "u-cursor-pointer",
        tabIndex: 0,
        "data-testid": "auth-select-type--".concat(selectType, "-switch"),
        children: /*#__PURE__*/_jsx(Text, {
          text: translate('actions.switch.link'),
          theme: "primary"
        })
      })]
    })]
  });
};

export default SelectTypeFooter;